module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-black.4376171c.gif";